import { render, staticRenderFns } from "./EditPageDetails.vue?vue&type=template&id=6676bb8e&scoped=true&"
import script from "./EditPageDetails.vue?vue&type=script&lang=js&"
export * from "./EditPageDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditPageDetails.vue?vue&type=style&index=0&id=6676bb8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676bb8e",
  null
  
)

export default component.exports